module.exports = __webpack_public_path__ + "static/media/LogicWedge2_4_drag_1.633b8a75.png";